module.exports = __webpack_public_path__ + "static/media/parceiro(9).4985a81c.png";